/**
 * 3.1.3.2 외부 연동 IAP Tab Store
 *
 * @since 2018-08-02
 * @author devp020
 */

import {i18n} from '~/plugins/i18n'
import compareObject from '~/utils/compare'

const initIapSettinsData = () => {
  return {
    device_id: [],
    device_list_name: '',
    iap_cm_block_yn: 1,
    iap_cm_desc: '',
    iap_cm_device: [],
    iap_cm_id: 0,
    iap_cm_sync_yn: 1,
    iap_cm_uname: '',
    iap_cm_use_yn: 1
  }
}
export const state = () => ({
  // api url 목록
  apiUrl: {
    iapSettingsUrl: '/api/cm/blist-link'
  },

  // iap info
  iapInfoList: [],
  selectedData: initIapSettinsData(),
  iapSettingsResult: null,
  iapSettingsSyncResult: null,
  iapSensorIPList: [],
  iapSensorIPResult: null,
  selectRowItem: {}
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  // IAP 설정 편집 데이터 초기화
  iapSettingsResetData (state) {
    state.selectedData = initIapSettinsData()
  },
  // IAP 통합 설정 조회
  mutIapSettings (state, payload) {
    state.iapInfoList = payload.filter(item => {
      // item.device_id_list = '<div>' + item.iap_cm_device.map(item => {
      //   return item.device_uname
      // }).join('</div><div>') + '</div>'
      item.device_id_list = item.iap_cm_device.map(itm => itm.device_id)
      return item
    })
  },
  // IAP 설정 편집 데이터 조회
  mutIapSettingsGetData (state, data) {
    const selectedRowData = data[0]
    selectedRowData.device_list_name = ''
    selectedRowData.device_id_list = []
    const deviceInfo = selectedRowData.iap_cm_device
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      let result = void 0
      if (deviceLen > 1) {
        // result = `${deviceName} 외 ${deviceLen - 1} 대`
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_list_name = result
      selectedRowData.device_id_list = deviceInfo.map(item => item.device_id)
    }
    state.selectedData = selectedRowData
  },
  // IAP 통합 설정 추가 (빈설정)
  mutAddEmptySettings: (state, item) => {
    state.iapInfoList.push(item)
  },
  // IAP 통합 설정 완료 처리 / 수정
  mutPutIapSettings (state, payload) {
    state.iapSettingsResult = payload
  },
  // IAP 통합 설정 삭제
  mutDelIapSettings (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.iapSettingsResult.splice(itemIndex, 1)
    }
  },
  // IAP 통합 설정 사용여부 수정
  mutPutIapSettingsSync (state, payload) {
    state.iapSettingsSyncResult = payload
  },
  // IAP 센서 IP 조회
  mutIapSensorIP (state, payload) {
    state.iapSensorIPList = payload
  },
  mutIapSensorIPReset (state) {
    state.iapSensorIPList = []
  },
  // IAP 센서 IP 추가
  mutPostIapSensorIP (state, payload) {
    state.iapSensorIPResult = payload
  },
  // IAP 센서 IP 삭제
  mutDelIapSensorIP (state, payload) {
    state.iapSensorIPResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  async applyAction () {
    const result = await this.$axios.$put(`/api/cm/blist-link/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelAction () {
    const result = await this.$axios.$put(`/api/cm/blist-link/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // IAP 통합 설정 조회
  async acsIapSettings ({commit, state}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.iapSettingsUrl}/0`, {loading: false})
      if (res.code === 'ok') {
        commit('mutIapSettings', res.result)
      } else {
        commit('mutIapSettings', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // IAP 설정 편집 데이터 조회
  async acsIapSettingsGetData ({commit, state}, iapCmId) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.iapSettingsUrl}/${iapCmId}`)
      if (res.code === 'ok') {
        commit('mutIapSettingsGetData', res.result)
        return true
      } else {
        commit('mutIapSettingsGetData', {})
        return false
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
      return false
    }
  },
  // IAP 통합 설정 추가 (빈설정)
  async acsAddEmptySettings ({commit, state}) {
    const param = _.omit(state.selectedData, ['iap_cm_id'])
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.iapSettingsUrl}`, param, {loading: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // IAP 통합 설정 완료 처리 / 수정
  async acsPutIapSettings ({commit, state}) {
    const result = { error: null }
    const params = state.selectedData
    // 수정 인 경우 device_id 추가
    if (state.selectedData.device_id === undefined) {
      params.device_id = []
      state.selectedData.iap_cm_device.forEach(item => {
        params.device_id.push(item.device_id)
      })
    }

    try {
      const res = await this.$axios.$put(`${state.apiUrl.iapSettingsUrl}/${params.iap_cm_id}`, params, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutPutIapSettings', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // IAP 통합 설정 삭제
  async acsDelIapSettings ({commit, state}, param) {
    const result = { error: null }

    try {
      const data = await this.$axios.$put(`${state.apiUrl.iapSettingsUrl}`, param.idList, {loading: false, successAlert: false})
      if (data.code === 'ok') {
        // commit('mutDelIapSettings', param.idList) // 삭제시에 다시 조회함으로 해당부분 제외.
        return 'ok'
      } else {
        result.error = data.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // IAP 통합 설정 사용여부 수정
  async acsPutIapSettingsSync ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.iapSettingsUrl}/multi`, payload)
      if (res.code === 'ok') {
        commit('mutPutIapSettingsSync', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // IAP 센서 IP 조회
  async acsIapSensorIP ({commit, state}, iapCmId) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.iapSettingsUrl}/sensor/${iapCmId}`)
      if (res.code === 'ok') {
        commit('mutIapSensorIP', res.result)
        return true
      } else {
        commit('mutIapSensorIP', [])
        return false
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
      return false
    }
  },
  // IAP 센서 IP 추가
  async acsPostIapSensorIP ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.iapSettingsUrl}/sensor`, payload, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutPostIapSensorIP', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // IAP 센서 IP 삭제
  async acsDelIapSensorIP ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.iapSettingsUrl}/sensor`, payload, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutDelIapSensorIP', data)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.iapSettingsUrl}/multi`, param, {loading: false, successAlert: false})

      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const getters = {
  compareIapInfoData () {
    const iapInfoProperties = {
      // use: state.iapInfo.use,
      // block: state.iapInfo.block,
      // sensor: state.iapInfo.sensor
    }
    const iapInfoCloneProperties = {
      // use: state.iapInfoClone.use,
      // block: state.iapInfoClone.block,
      // sensor: state.iapInfoClone.sensor
    }
    return compareObject(iapInfoProperties, iapInfoCloneProperties)
  }
}

export const strict = false
